import { styleConstants, themeConstants } from '@paywithextend/components'
import Button from 'ext-ui/components/Button/Button'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import TextInputField, {
  TextInputFieldDesigns,
} from 'src/components/TextInputField/TextInputField'
import { ConfirmDowngradeSubscriptionText } from 'src/constants'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns, { useTranslate } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

import style from './CancelSubscription.style'

interface CancelSubscriptionSubmissionProps {
  onConfirm: () => void
  onCancel: () => void
}

export default function CancelSubscriptionSubmission(
  props: CancelSubscriptionSubmissionProps,
): React.ReactElement {
  const [downgradeConfirmationText, setDowngradeConfirmationText] = useState('')
  const [downgradeConfirmationValid, setDowngradeConfirmationValid] =
    useState(false)
  const locale = useSelector(selectNullSafeLocaleFromState)
  const listImage = useColorOrGrayscaleImage(ImageNames.List)

  const translate = useTranslate()

  useEffect(() => {
    const confirmationText = downgradeConfirmationText.toUpperCase()
    setDowngradeConfirmationValid(
      confirmationText === ConfirmDowngradeSubscriptionText[locale],
    )
  }, [downgradeConfirmationText])

  return (
    <div css={style}>
      <img
        src={listImage}
        alt="list"
        className="CancelSubscription-list-image"
      />
      <div className="CancelSubscription-container">
        <div className="CancelSubscription-text">
          <div className="CancelSubscription-header">
            {translate('Confirm Pro plan cancellation')}
          </div>
          <div className="CancelSubscription-subtext">
            {/* TODO: Replace with useTranslate */}
            <Trns
              source={
                "Your Pro plan will remain active until the end of your current billing period. After that, Pro features will be disabled and you'll need to remove any extra users from your organization. For billing questions, contact us at ${billingEmail}."
              }
              expressions={{
                billingEmail: (
                  <a
                    css={css`
                      font-size: 16px;
                      color: ${themeConstants.colors.cta};
                      font-family: ${styleConstants.fontFamilies.regular};
                      text-decoration: underline;
                    `}
                    href={`mailto:billing@paywithextend.com`}
                  >
                    {'billing@paywithextend.com'}
                  </a>
                ),
              }}
            />
          </div>
        </div>
        <div className="CancelSubscription-submission-container">
          <div className="CancelSubscription-submission-instructions">
            {/* TODO: Replace with useTranslate */}
            <Trns
              source={'Confirm by typing ${downgrade} below:'}
              expressions={{
                downgrade: (
                  <span className="CancelSubscription-red-downgrade-text">
                    <Trns source={'DOWNGRADE'} />
                  </span>
                ),
              }}
            />
          </div>
          <div className="CancelSubscription-submission-input">
            <TextInputField
              design={TextInputFieldDesigns.New}
              placeholder={translate('Please type DOWNGRADE')}
              value={downgradeConfirmationText}
              onChange={(value: string): void =>
                setDowngradeConfirmationText(value.toUpperCase())
              }
            />
          </div>
        </div>
        <div className="CancelSubscription-button-container">
          <Button
            variant="severe"
            onClick={props.onConfirm}
            disabled={!downgradeConfirmationValid}
          >
            {translate('Downgrade Plan')}
          </Button>
          <Button variant="no-border" onClick={props.onCancel}>
            {translate('Cancel')}
          </Button>
        </div>
      </div>
    </div>
  )
}
